exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Hind+Madurai:400,700);", ""]);
var urlEscape = require("../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("assets/fonts/HindMysuru-Bold.otf"));

// Module
exports.push([module.id, "@font-face{font-family:\"HindMysuru-Bold\";src:url(" + ___CSS_LOADER_URL___0___ + ") format(\"opentype\")}#icon-button[data-v-28c30394]{width:28px;height:28px;transition:60ms opacity ease-out}#icon-button[data-v-28c30394]:hover{opacity:.8}\n", ""]);

